import { MessageTypes } from "../../reducer/General/_interfaces";
import { RESET_GLOBAL_MESSAGE, SET_GLOBAL_MESSAGE } from "../../reducer/General/constants";



export const setGeneralMessage = (messages:string[], type:MessageTypes, canDismiss:boolean = true) => (dispatch:any) => {
    dispatch({
        type: SET_GLOBAL_MESSAGE,
        payload: {
            type,
            text: messages,
            canDismiss
        }
    });
}

export const resetGeneralMessage = () => (dispatch:any) => {
    dispatch({
        type: RESET_GLOBAL_MESSAGE,
        payload: null,
    });
}
